export default "__VITE_ASSET__bd8f6311__"